<template>
	<div>
    <div class="m-right-title" ><div  style="float: left;">学习课程</div> &nbsp;&nbsp;&nbsp;&nbsp;<div style="color: #1b87ef;float: right;font-size: 18px;">到期时间：{{ remainingTime.days }} 天 {{ remainingTime.hours }} 时 {{ remainingTime.minutes }} 分 {{ remainingTime.seconds }} 秒</div></div>

		<div class="m-list" v-loading="loading">
			<div class="m-item" v-for="(item,index) in list">
				<div class="m-item-img">
					<div class="m-item-tip">{{item.type == 1 ? '视频' : '文件'}}</div>
					<img :src="item.cover" />
				</div>
				<div class="m-item-con u-m-l-16">
					<p class="u-line-2 m-item-font1">{{item.name}}</p>
					<h3 class="u-line-2 m-item-font1" style="font-size:14px;color:red;font-weight: normal;" v-if="item.lastInfo"><span style="font-weight: normal;color: rgb(27, 135, 239);">上次学习到：</span>{{item.lastInfo}}</h3>
					<div class="u-flex">
						<div class="m-item-time">
							<img src="../../assets/img/common/icon-time4.png" />
							<span class="u-m-l-6">学时安排：{{item.period}}</span>
						</div>
						<div class="m-item-jindu u-m-l-30">
							<span>学习进度：</span>
						</div>
							<el-progress style="width: 200px;" :percentage="item.schedule" :stroke-width="10"></el-progress>
					</div>
				</div>
				<div class="u-flex-col u-flex-1 u-col-bottom">
					<div class="m-item-btn"  @click="to_course(item)">去学习</div>
					<!-- <template v-if="item.status == 2"> -->
						<div class="m-item-btn m-item-btn-extend u-m-t-8" @click="start_practice(item)">答题练习</div>
						<div class="m-item-btn m-item-btn-extend u-m-t-8" v-if="item.has_case" @click="to_link('/center/case',{course_id:item.id})">案例题练习</div>
						<div class="m-item-btn m-item-btn-extend u-m-t-8" @click="to_link('/center/test2',{paper_id:item.paper_id})">考试</div>
					<!-- </template> -->
				</div>
			</div>
		</div>
		<div class="u-flex u-row-center u-m-b-60">
			<el-pagination
			  background
			  layout="prev, pager, next"
			  @current-change="currentChange"
			  :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import {to_link} from "@/router/api"
	import {studyRecord} from "@/api/center.js"
	export default {
		data(){
			return {
				loading:false,
				total:0,
				list:[],
				params:{
					page:1,
					pageNum:10
				},
        targetDate: new Date(this.$store.state.user_info.end_time), // 目标日期
        remainingTime: {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        }
			}
		},
		mounted() {
			this.getList()
      const userEndTime = this.$store.state.user_info.end_time; // 替换为实际的end_time
      const endTimeTimestamp = Date.parse(userEndTime);
      this.targetDate= new Date(endTimeTimestamp); // 目标日期
      this.updateCountdown();
      setInterval(this.updateCountdown, 1000);
		},
		methods:{
      //计算倒计时
      updateCountdown() {
        const currentDate = new Date();
        const timeDifference = this.targetDate.getTime() - currentDate.getTime();

        // 计算剩余的天、时、分、秒
        this.remainingTime.days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        this.remainingTime.hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        this.remainingTime.minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        this.remainingTime.seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
      },
			to_link,
			start_practice(item){
				if(item.is_cate == 0){
					to_link('/center/test',{course_id:item.id,cate_id:item.cate_id})
				}else{
					to_link('/center/testCate',{course_id:item.id,cate_id:item.cate_id})
				}
			},
			currentChange(e){
				this.params.page = 1
				this.getList()
			},
			//课程详情
			to_course(item){
				if(item.type == 1){
					to_link('/video',{id:item.id})
				}else{
					to_link('/files',{id:item.id})
				}
			},
			async getList(){
				this.loading = true
				let res = await studyRecord(this.params)
				setTimeout(()=>{
					this.loading = false
				},500)
				if(res.code == 200){
					// console.log(res.data)
					this.total = res.count ||0
					this.list = res.data
				}else{
					this.$message.error(res.message)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.m-right-title{
		height: 64px;
		line-height: 20px;
		padding-top: 22px;
		padding-right: 32px;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #000000;
		padding-left: 38px;
		border-bottom: 1px solid #EEEEEE;
		box-sizing: border-box;
	}
	.m-list{
		display: flex;
		flex-direction: column;
		padding-top: 20px;
		padding-left: 38px;
		padding-right: 38px;
		padding-bottom: 60px;
		.m-item{
			display: flex;
			height: 90px;
			margin-right: 22px;
			box-sizing: content-box;
			padding: 22px 0;
			cursor: pointer;
			border-bottom: 1px dashed #D1D1D1;
			.m-item-font1{
				font-size: 14px;
				color: #505050;
				line-height: 22px;
			}
			.m-item-img{
				position: relative;
				width: 160px;
				height: 90px;
				display: flex;
				align-items: center;
				overflow: hidden;
				.m-item-tip{
					position: absolute;
					top: 11px;
					left: 0;
					z-index: 1;
					width: 40px;
					height: 20px;
					font-size: 14px;
					color: #fff;
					opacity: 0.5;
					background: #000;
					text-align: center;
					line-height: 20px;
				}
				img{
					width: 100%;
				}
			}
			.m-item-jindu{
				display: flex;
				color: #D6102A;
				font-size: 14px;
			}
			.m-item-con{
				display: flex;
				flex-direction: column;
				width: 480px;
				height: 90px;
				justify-content: space-between;
				
			}
			.m-item-time{
				display: flex;
				align-items: center;
				color: #7C7C7C;
				font-size: 14px;
				line-height: 14px;
			}
			.m-item-btn{
				display: flex;
				align-items: center;
				justify-content: center;
				width: 117px;
				height: 35px;
				background: #F8A310;
				border-radius: 18px;
				font-size: 14px;
				color: #fff;
			}
			.m-item-btn-extend{
				background: #D6102A;
			}
		}
	}
</style>

<style lang="scss">
	.m-item-con{
		.el-progress-bar__inner{
			background-color: #D6102A;
		}
	}
</style>
